module.exports = __webpack_public_path__ + "static/media/briefcase-26.bdafefd2.svg";